export class DefaultEmailTemplate {
   public static readonly type = '[DefaultEmailTemplate] Selected';

   constructor(public templateId: number) {}
}
